export default "__VITE_ASSET__BmGCxIvX__"